export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "PO-Revision-Date": "2025-01-16T18:28:34.737Z",
    "Last-Translator": "",
    "Language-Team": "",
    "Language": "en-US",
    "Messages": {
        "1": "1",
        "2": "2",
        "3": "3",
        "4": "4",
        "5": "5",
        "6": "6",
        "7": "7",
        "8": "8",
        "9": "9",
        "10": "10",
        "15": "15",
        "20": "20",
        "25": "25",
        "Adres": "Address",
        "Adres dostawy": "Delivery address",
        "Adres e-mail": "Email address",
        "Adres email użytkownika": "User email address",
        "Adres IP użytkownika": "User IP address",
        "Aktualizuj cennik": "Update price list",
        "Aktywacja produktów": "Product activation",
        "Aktywna": "Active",
        "Aktywuj": "Activate",
        "Alert": "Alert",
        "Anulowana": "Cancelled",
        "Anuluj": "Cancel",
        "Anuluj edycję": "Cancel edit",
        "API Key": "API Key",
        "API Key Location": "API Key Location",
        "API Key Tracking": "API Key Tracking",
        "Automatyczna akceptacja": "Automatic approval",
        "Autor": "Author",
        "Bezwzględny": "Absolute",
        "brak": "none",
        "Brak": "None",
        "Brak cech w grupie": "No attributes in group",
        "Brak historii statusów": "No status history",
        "Brak kategorii": "No categories",
        "Brak kategorii nadrzędnej": "No parent category",
        "Brak kategorii w grupie": "No categories in group",
        "Brak kolekcji w kolekcji": "No collections in collection",
        "Brak komentarza": "No comment",
        "Brak notatek": "No notes",
        "Brak produktów w kolekcji": "No products in collection",
        "Brak reklamacji": "No complaints",
        "Brak tłumaczenia": "No translation",
        "Brak w magazynie": "Out of stock",
        "Brak wybranych etykiet": "No selected labels",
        "Brak wybranych producentów": "No selected manufacturers",
        "Brak wybranych produktów": "No selected products",
        "Brak wyników": "No results",
        "Brutto": "Gross",
        "Cecha została dodana.": "Attribute has been added.",
        "Cecha została usunięta.": "Attribute has been deleted.",
        "Cecha została zaktualizowana.": "Attribute has been updated.",
        "Cechy": "Attributes",
        "Cechy odziedziczone po kategoriach nadrzędnych": "Attributes inherited from parent categories",
        "Cechy w grupie": "Attributes in group",
        "Cena aktualna brutto": "Current gross price",
        "Cena aktualna netto": "Current net price",
        "Cena brutto": "Gross price",
        "Cena brutto do": "Gross price to",
        "Cena brutto od": "Gross price from",
        "Cena dostawy": "Delivery price",
        "Cena łączna": "Total price",
        "Cena łączna produktu": "Total product price",
        "Cena netto": "Net price",
        "Cena netto do": "Net price to",
        "Cena netto od": "Net price from",
        "Cena produktów": "Product price",
        "Cena regularna brutto": "Regular gross price",
        "Cena regularna netto": "Regular net price",
        "Cena sugerowana brutto": "Suggested gross price",
        "Cena sugerowana netto": "Suggested net price",
        "Cena zamówienia": "Order price",
        "Cennik został dodany.": "Price list has been added.",
        "Cennik został zaaktualizowany": "Price list has been updated",
        "Cenniki": "Price lists",
        "Ceny dostawy": "Delivery prices",
        "Client ID": "Client ID",
        "Client Secret": "Client Secret",
        "CRC": "CRC",
        "Customer ID": "Customer ID",
        "Czas dostawy": "Delivery time",
        "Czas na zgłoszenie reklamacji (w dniach)": "Time to submit complaint (in days)",
        "Czas na zgłoszenie zwrotu (w dniach)": "Time to submit return (in days)",
        "Dane do faktury": "Invoice details",
        "Dane zostały zapisane": "Data has been saved",
        "Darmowa dostawa": "Free delivery",
        "Darmowa przesyłka od kwoty (brutto)": "Free shipping from amount (gross)",
        "Data": "Date",
        "Data do": "Date to",
        "Data dodania": "Date added",
        "Data modyfikacji": "Modification date",
        "Data od": "Date from",
        "Data płatności": "Payment date",
        "Data rozpoczęcia": "Start date",
        "Data rozpoczęcia publikacji jest wymagana": "Publication start date is required",
        "Data rozpoczęcia rekomendacji": "Recommendation start date",
        "Data ustawienia": "Set date",
        "Data utworzenia": "Creation date",
        "Data wystawienia opinii": "Review issue date",
        "Data zakończenia": "End date",
        "Data zakończenia rekomendacji": "Recommendation end date",
        "Data zmiany ceny": "Price change date",
        "Dev": "Dev",
        "Dezaktywacja wpis": "Deactivate entry",
        "Dezaktywuj": "Deactivate",
        "Dhl": "Dhl",
        "DHL": "DHL",
        "Długość kodu": "Code length",
        "Dni tygodnia w których jest wysyłane zamówienie": "Days of week when order is shipped",
        "Do wysłania (data)": "To be sent (date)",
        "Dodaj": "Add",
        "Dodaj cechę": "Add attribute",
        "Dodaj cennik": "Add price list",
        "Dodaj etykietę": "Add label",
        "Dodaj fakturę": "Add invoice",
        "Dodaj grupę cech": "Add attribute group",
        "Dodaj katalog": "Add catalog",
        "Dodaj kategorię": "Add category",
        "Dodaj kody": "Add codes",
        "Dodaj kolekcję": "Add collection",
        "Dodaj kraj": "Add country",
        "Dodaj notatkę": "Add note",
        "Dodaj nowy katalog aby rozpocząć zarządzanie kategoriami.": "Add new catalog to start managing categories.",
        "Dodaj parametr UTM": "Add UTM parameter",
        "Dodaj producenta": "Add manufacturer",
        "Dodaj produkt": "Add product",
        "Dodaj promocję": "Add promotion",
        "Dodaj sklep": "Add store",
        "Dodaj sposób dostawy": "Add delivery method",
        "Dodaj sposób płatności": "Add payment method",
        "Dodaj stawkę": "Add rate",
        "Dodaj walutę": "Add currency",
        "Dodaj wartość": "Add value",
        "Dodaj wpis w kalendarzu": "Add calendar entry",
        "Dodaj zakres": "Add range",
        "Dodane przez": "Added by",
        "Dodanie cechy": "Adding attribute",
        "Dodanie cennika": "Adding price list",
        "Dodanie etykiety": "Adding label",
        "Dodanie faktury": "Adding invoice",
        "Dodanie grupy cech": "Adding attribute group",
        "Dodanie kategorii": "Adding category",
        "Dodanie kolekcji": "Adding collection",
        "Dodanie kraju": "Adding country",
        "Dodanie opcji dostawy": "Adding delivery option",
        "Dodanie opcji płatności": "Adding payment option",
        "Dodanie parametru UTM": "Adding UTM parameter",
        "Dodanie producenta": "Adding manufacturer",
        "Dodanie produktu": "Adding product",
        "Dodanie promocji": "Adding promotion",
        "Dodanie sklepów": "Adding stores",
        "Dodanie stawki": "Adding rate",
        "Dodanie waluty": "Adding currency",
        "Dodanie wartości": "Adding value",
        "Dodanie wpisu do kalendarza": "Adding calendar entry",
        "Dodawanie etykiet": "Adding labels",
        "Dodawanie kategorii": "Adding categories",
        "Dodawanie kodów": "Adding codes",
        "Dodawanie kolekcji": "Adding collections",
        "Dodawanie producenta": "Adding manufacturer",
        "Dokonaj dopłaty faktury": "Make invoice surcharge payment",
        "Domyślna waluta": "Default currency",
        "Domyślny limit (brutto)": "Default limit (gross)",
        "Dopłacenie faktury": "Invoice surcharge payment",
        "Dopłać": "Pay extra",
        "Dopuszczalne parametry pojedynczego produktu": "Allowed parameters of single product",
        "Dostawa": "Delivery",
        "Dostawa na palecie": "Pallet delivery",
        "Dostawa w godzinach wieczornych": "Evening delivery",
        "Dostawa w sobotę": "Saturday delivery",
        "Dostawy": "Deliveries",
        "Dotpay": "Dotpay",
        "Drugi klucz (MD5)": "Second key (MD5)",
        "Działania masowe": "Bulk actions",
        "EAN-13": "EAN-13",
        "Edycja": "edit",
        "Edycja cechy": "edit attribute",
        "Edycja cennika": "edit price list",
        "Edycja etykiety": "edit label",
        "Edycja grupy cech": "edit attribute group",
        "Edycja kategorii": "edit category",
        "Edycja kolekcji": "edit collection",
        "Edycja kraju": "edit country",
        "Edycja opcji dostawy": "edit delivery option",
        "Edycja opcji płatności": "edit payment option",
        "Edycja parametru UTM": "edit UTM parameter",
        "Edycja producenta": "edit manufacturer",
        "Edycja produktu": "edit product",
        "Edycja promocji": "edit promotion",
        "Edycja sklepów": "edit stores",
        "Edycja stawki": "edit rate",
        "Edycja waluty": "edit currency",
        "Edycja wpisu do kalendarza": "edit calendar entry",
        "Edytuj": "Edit",
        "Edytuj katalog": "Edit catalog",
        "Edytuj notatkę": "Edit note",
        "Eksportuj": "Export",
        "Email użytkownika": "User email",
        "Etykieta": "Label",
        "Etykieta priorytetowa": "Priority label",
        "Etykieta produktu została dodana.": "Product label has been added.",
        "Etykieta produktu została usunięta.": "Product label has been deleted.",
        "Etykieta produktu została zaktualizowana.": "Product label has been updated.",
        "Etykiety": "Labels",
        "Faktura została dodana.": "Invoice has been added.",
        "Faktura została zaktualizowana.": "Invoice has been updated.",
        "Faktury": "Invoices",
        "Firma": "Company",
        "Format ceny": "Price format",
        "Format kodu pocztowego": "Postal code format",
        "Format kodu powinien być wyrażeniem regularnym": "Code format should be regular expression",
        "Formularz": "Form",
        "Generowanie kodów": "Code generation",
        "Generuj nowe kody": "Generate new codes",
        "Generuj warianty": "Generate variants",
        "Generuj wszystkie metadane": "Generate all metadata",
        "Głębokość": "Depth",
        "Godzina wysyłki zamówień": "Order shipping time",
        "grid": "grid",
        "Grupa cech": "Attribute group",
        "Grupa cech została dodana.": "Attribute group has been added.",
        "Grupa cech została usunięta.": "Attribute group has been deleted.",
        "Grupa cech została zaktualizowana.": "Attribute group has been updated.",
        "Grupy cech": "Attribute groups",
        "Hasło użytkownika": "User password",
        "Historia cenony produktu została zdezaktywowana.": "Product price history has been deactivated.",
        "Historia faktur": "Invoice history",
        "Historia statusów": "Status history",
        "Historia zmian cen produktu": "Product price change history",
        "Id": "Id",
        "ID": "ID",
        "ID organizacji": "Organization ID",
        "Id punktu płatności (pos_id)": "Payment point ID (pos_id)",
        "ID sklepu": "Store ID",
        "Identyfikator sklepu (domyślnie id sprzedawcy)": "Store identifier (seller ID by default)",
        "Identyfikator sprzedawcy": "Seller identifier",
        "Ikona wartości": "Value icon",
        "Ilość": "Quantity",
        "Ilość produktu jaka ma zostać w magazynie. W pierwszej kolejności brana po uwagę jest wartość z wariantu, następnie z produktu a na końcu z kategorii.": "Product quantity that should remain in stock. Value from variant is taken into account first, then from product, and finally from category.",
        "Ilość reklamowana": "Claimed quantity",
        "Ilość w magazynie": "Stock quantity",
        "Ilość w magazynie do": "Stock quantity to",
        "Ilość w magazynie od": "Stock quantity from",
        "Imię": "First name",
        "Imię klienta": "Customer first name",
        "Indywidualny": "Individual",
        "Inpost": "Inpost",
        "Jeśli nazwa wyświetlana nie zostanie ustawiona, to zostanie użyta nazwa kategorii.": "If display name is not set, category name will be used.",
        "Język": "Language",
        "Kalendarz": "Calendar",
        "Kampania (utm_campaign)": "Campaign (utm_campaign)",
        "Kampanie": "Campaigns",
        "Katalog": "Catalog",
        "Katalog został usunięty.": "Catalog has been deleted.",
        "Katalog został utworzony.": "Catalog has been created.",
        "Katalogi kategorii": "Category catalogs",
        "Kategoria": "Category",
        "Kategoria główna": "Main category",
        "Kategoria nadrzędna": "Parent category",
        "Kategoria widoczna": "Visible category",
        "Kategorie": "Categories",
        "Klient": "Customer",
        "Kod": "Code",
        "Kod ISO": "ISO code",
        "Kod pocztowy": "Postal code",
        "Kod rabatowy": "Discount code",
        "Kod został usunięty.": "Code has been deleted.",
        "Kody promocyjne zostały dodane.": "Promotional codes have been added.",
        "Kody promocyjne zostały wygenerowane.": "Promotional codes have been generated.",
        "Kody rabatowe": "Discount codes",
        "Kody zostały usunięte.": "Codes have been deleted.",
        "Kolekcja aktywna": "Active collection",
        "Kolekcja została dodana.": "Collection has been added.",
        "Kolekcja została zaktualizowana.": "Collection has been updated.",
        "Kolekcje": "Collections",
        "Kolor dekoracji tekstu": "Text decoration color",
        "Kolor obramowania": "Border color",
        "Kolor tekstu": "Text color",
        "Kolor tła": "Background color",
        "Komentarz": "Comment",
        "Komentarz do zamówienia": "Order comment",
        "Konfiguracja": "Configuration",
        "Konfiguruj kategorię": "Configure category",
        "Kopiuj": "Copy",
        "Koszt płatności": "Payment cost",
        "Koszt płatności brutto": "Gross payment cost",
        "Kraj": "Country",
        "Kraj produkcji": "Country of production",
        "Kraj został dodany.": "Country has been added.",
        "Kraj został usunięty.": "Country has been deleted.",
        "Kraj został zaktualizowany.": "Country has been updated.",
        "Kraje": "Countries",
        "Kupujący": "Buyer",
        "Kurs": "Rate",
        "Kwota brutto": "Gross amount",
        "Kwota netto": "Net amount",
        "Legacy": "Legacy",
        "Liczba dni przechowywania": "Number of storage days",
        "Liczba kodów promocyjnych": "Number of promotional codes",
        "Liczba nowych kodów": "Number of new codes",
        "Liczba użyć": "Number of uses",
        "Liczba wyświetlanych produktów": "Number of displayed products",
        "Limit czasowy rezerwacji (w minutach)": "Reservation time limit (in minutes)",
        "Limit kupiecki": "Trade credit limit",
        "Lista dostawców obsługujących ten sklep oraz rodzaje płatności dostępne po wybraniu określonego dostawcy podczas składania zamówienia.": "List of suppliers serving this store and payment types available after selecting specific supplier during checkout.",
        "Logo": "Logo",
        "lub wpisz wartość": "or enter value",
        "Maksimum logistyczne": "Logistics maximum",
        "Maksymalna głębokość": "Maximum depth",
        "Maksymalna liczba produktów": "Maximum number of products",
        "Maksymalna liczba użyć": "Maximum number of uses",
        "Maksymalna szerokość": "Maximum width",
        "Maksymalna waga": "Maximum weight",
        "Maksymalna wartość rabatu": "Maximum discount value",
        "Maksymalna wartość zamówienia (brutto)": "Maximum order value (gross)",
        "Maksymalna wysokość": "Maximum height",
        "Margines dla produktów": "Margin for products",
        "Marketing": "Marketing",
        "Media": "Media",
        "Medium (utm_medium)": "Medium (utm_medium)",
        "Metadane": "Metadata",
        "Metody płatności": "Payment methods",
        "Miasto": "City",
        "Miniaturka": "Thumbnail",
        "Minimum logistyczne": "Logistics minimum",
        "Mnożnik": "Multiplier",
        "Moduł dostawy": "Delivery module",
        "Moduł płatności": "Payment module",
        "MPN": "MPN",
        "Multimedia": "Multimedia",
        "Na status": "To status",
        "Na stronie": "On page",
        "Nadkreślenie": "Overline",
        "Najniższa cena z 30 dni brutto": "Lowest gross price from 30 days",
        "Najniższa cena z 30 dni netto": "Lowest net price from 30 days",
        "Najpierw zapisz wprowadzone zmiany": "Save entered changes first",
        "Należy pamiętać, że może istnieć tylko jeden ciąg zmiennych.nnMożliwe zmienne do użycia:n- %d - Cyfry (0-9)n- %s - Litery (A-Z)": "Please note that only one variable string can exist.nnPossible variables to use:n- %d - Digits (0-9)n- %s - Letters (A-Z)",
        "Name": "Name",
        "Nazwa": "Name",
        "Nazwa cechy": "Attribute name",
        "Nazwa firmy": "Company name",
        "Nazwa grupy cech": "Attribute group name",
        "Nazwa kategorii": "Category name",
        "Nazwa klienta": "Customer name",
        "Nazwa kolekcji": "Collection name",
        "Nazwa parametru": "Parameter name",
        "Nazwa producenta": "Manufacturer name",
        "Nazwa produktu": "Product name",
        "Nazwa promocji": "Promotion name",
        "Nazwa sklepu": "Store name",
        "Nazwa sposobu dostawy": "Delivery method name",
        "Nazwa sposobu płatności": "Payment method name",
        "Nazwa użytkownika": "Username",
        "Nazwa wpisu do kalendarza": "Calendar entry name",
        "Nazwa wyświetlana": "Display name",
        "Nazwisko": "Last name",
        "Nazwisko klienta": "Customer last name",
        "Netto": "Net",
        "Nie": "No",
        "Nie pozwól zamówić": "Do not allow ordering",
        "Nie udało się pobrać listy kategorii": "Failed to fetch category list",
        "Nie udało się pobrać ustawień kont użytkowników": "Failed to fetch user account settings",
        "Nie udało się załadować widgetu źródło pochodzenia zamówienia.": "Failed to load order source widget.",
        "Nie wybrano żadnego produktu.": "No product selected.",
        "Nie wybrano żadnej opinii.": "No review selected.",
        "Nie znaleziono reklamacji": "No complaints found",
        "Niektóre wersje językowe zostały już przypisane do innych sklepów.": "Some language versions have already been assigned to other stores.",
        "Nielimitowana": "Unlimited",
        "Niestandardowa wiadomość": "Custom message",
        "Niestandardowy wzór": "Custom pattern",
        "NIP": "Tax ID",
        "Notatka": "Note",
        "Notatka została dodana.": "Note has been added.",
        "Notatka została usunięta.": "Note has been deleted.",
        "Notatka została zapisana.": "Note has been saved.",
        "Notatki": "Notes",
        "Numer": "Number",
        "Numer budynku": "Building number",
        "Numer domu / mieszkania": "House / apartment number",
        "Numer faktury": "Invoice number",
        "Numer kierunkowy": "Dialing code",
        "Numer konta": "Account number",
        "Numer reklamacji": "Complaint number",
        "Numer telefonu": "Phone number",
        "Numer zamówienia": "Order number",
        "Numer zgłoszenia": "Request number",
        "Ocena": "Rating",
        "Oceniony produkt": "Rated product",
        "Oczekujące": "Pending",
        "Odbiorca": "Recipient",
        "Odbiorca (firma)": "Recipient (company)",
        "Odrzucone": "Rejected",
        "Odstęp górnej oraz dolnej krawędzi od tekstu": "Spacing of top and bottom edge from text",
        "Odstęp lewej oraz prawej krawędzi od tekstu": "Spacing of left and right edge from text",
        "Ogólne": "General",
        "Opcja dodatkowa": "Additional option",
        "Operacja spowoduje trwałe usunięcie wszystkich kategorii należących do tego katalogu!nnCzy na pewno chcesz wykonać akcję?": "Operation will permanently delete all categories belonging to this catalog!nnAre you sure you want to perform this action?",
        "Opinia została usunięta.": "Review has been deleted.",
        "Opinie": "Reviews",
        "Opinie produktowe": "Product reviews",
        "Opinie zostały zaktualizowane": "Reviews have been updated",
        "Opis": "Description",
        "Opis wartości": "Value description",
        "Opis zmiany": "Change description",
        "Opisy": "Descriptions",
        "Opłacona": "Paid",
        "Opublikowany": "Published",
        "Osoba fizyczna": "Natural person",
        "Ostatnio zmodyfikowane": "Last modified",
        "Parametr UTM został dodany.": "UTM parameter has been added.",
        "Parametr UTM został zaktualizowany.": "UTM parameter has been updated.",
        "Parametr został usunięty.": "Parameter has been deleted.",
        "Parametry logistyczne": "Logistics parameters",
        "Parametry UTM": "UTM parameters",
        "PayPal": "PayPal",
        "PayU": "PayU",
        "PIN": "PIN",
        "Plik faktury": "Invoice file",
        "Płatności": "Payments",
        "Płatność": "Payment",
        "Płatność za pobraniem": "Cash on delivery",
        "Po upływie tego czasu (liczonego od czasu utworzenia rezerwacji) rezerwacja przestanie obowiązywać (0 - brak limitu).": "After this time (counted from reservation creation time), reservation will expire (0 - no limit).",
        "Po upływie tego czasu nie bedzie można złożyć reklamacji. Czas naliczany jest od momentu zmiany statusu zamówienia na Zrealizowane. ": "After this time, it will not be possible to submit complaint. Time is counted from moment order status changes to Completed. ",
        "Po upływie tego czasu nie bedzie można złożyć zwrotu. Czas naliczany jest od momentu zmiany statusu zamówienia na Zrealizowane.": "After this time, it will not be possible to submit return. Time is counted from moment order status changes to Completed.",
        "Po wybraniu tej opcji opinie zostaną usunięte z systemu. Czy chcesz kontynuować?": "After selecting this option, reviews will be deleted from system. Do you want to continue?",
        "Po wybraniu tej opcji produkty zostaną usunięte z systemu. Czy chcesz kontynuować?": "After selecting this option, products will be deleted from system. Do you want to continue?",
        "Po wybraniu typu kodu, nie można go zmienić.": "After selecting code type, it cannot be changed.",
        "Pobierz etykietę": "Download label",
        "Pobierz etykiety": "Download labels",
        "Pobranie": "Download",
        "Pochylenie": "Italic",
        "Podatek": "Tax",
        "Podatki": "Taxes",
        "Podgląd": "Preview",
        "Podgląd kodu": "Code preview",
        "Podkreślenie": "Underline",
        "Podsumowanie": "Summary",
        "Pogrubienie": "Bold",
        "Pokaż kafelki do ostatniego poziomu": "Show tiles to last level",
        "Pokaż kafelki do wybranego poziomu": "Show tiles to selected level",
        "Posiada wagę": "Has weight",
        "Posiada zdjęcie": "Has image",
        "Potwierdzenie": "Confirmation",
        "Potwierdzenie kopiowania": "Copy confirmation",
        "Potwierdzenie usunięcia": "Delete confirmation",
        "Potwierdzenie usunięciannWykonanie tej akcji nie spowoduje usunięcia tej cechy przypisanej do produktów.": "Delete confirmationnnPerforming this action will not delete this attribute assigned to products.",
        "Powiadomienia": "Notifications",
        "Powrót": "Back",
        "Pozostałe parametry": "Other parameters",
        "Pozostałe zdjęcia": "Other images",
        "Pozwól zamawiać": "Allow ordering",
        "Priorytet": "Priority",
        "Procentowy": "Percentage",
        "Producenci": "Manufacturers",
        "Producent": "Manufacturer",
        "Producent aktywny": "Active manufacturer",
        "Producent został dodany.": "Manufacturer has been added.",
        "Producent został zaktualizowany.": "Manufacturer has been updated.",
        "Produkt": "Product",
        "Produkt bazowy": "Base product",
        "Produkt opublikowany": "Published product",
        "Produkt posiada warianty": "Product has variants",
        "Produkt rekomendowany": "Recommended product",
        "Produkt został dodany.": "Product has been added.",
        "Produkt został skopiowany.": "Product has been copied.",
        "Produkt został usunięty.": "Product has been deleted.",
        "Produkt został zaktualizowany.": "Product has been updated.",
        "Produkty": "Products",
        "Produkty komplementarne": "Complementary products",
        "Produkty rekomendowane": "Recommended products",
        "Produkty w promocji": "Products on promotion",
        "Produkty wraz z wariantami": "Products with variants",
        "Produkty zostały aktywowane": "Products have been activated",
        "Produkty zostały dezaktywowane": "Products have been deactivated",
        "Produkty zostały usunięte z systemu": "Products have been deleted from system",
        "Produkty zostały zaktualizowane": "Products have been updated",
        "Promocja włączona": "Promotion enabled",
        "Promocja została dodana.": "Promotion has been added.",
        "Promocja została usunięta.": "Promotion has been deleted.",
        "Promocja została zaktualizowana.": "Promotion has been updated.",
        "Promocje": "Promotions",
        "Protokół OAuth - client_id": "OAuth protocol - client_id",
        "Protokół OAuth - client_secret": "OAuth protocol - client_secret",
        "Przedrostek": "Prefix",
        "Przekreślenie": "Strikethrough",
        "Przekroczono dozwoloną liczbę znaków (255)": "Allowed number of characters exceeded (255)",
        "Przelew tradycyjny": "Traditional bank transfer",
        "Przelewy24": "Przelewy24",
        "przez": "by",
        "Przykład: ^\\d{5}$": "Example: ^\\d{5}$",
        "Przykład: 00000": "Example: 00000",
        "Przyrostek": "Suffix",
        "Publikuj do": "Publish to",
        "Publikuj od": "Publish from",
        "Reguła podatku": "Tax rule",
        "Reklamacje": "Complaints",
        "Reklamacje i zwroty": "Complaints and returns",
        "Rezerwacja stanów magazynowych": "Stock reservation",
        "Ręczna akceptacja": "Manual approval",
        "Rodzaj płatności": "Payment type",
        "Rozmiar paczki": "Package size",
        "Secret ID": "Secret ID",
        "Sklep": "Store",
        "Sklep został dodany.": "Store has been added.",
        "Sklep został usunięty.": "Store has been deleted.",
        "Sklep został zaktualizowany.": "Store has been updated.",
        "Sklepy": "Stores",
        "Skopiuj": "Copy",
        "SKU": "SKU",
        "slider": "slider",
        "Słowa kluczowe": "Keywords",
        "Sortowanie cech": "Attribute sorting",
        "Sortowanie grup cech": "Attribute group sorting",
        "Sortowanie wartości": "Value sorting",
        "Sortuj cechy": "Sort attributes",
        "Sortuj grupy cech": "Sort attribute groups",
        "Sortuj wartości": "Sort values",
        "Sposób dostawy": "Delivery method",
        "Sposób dostawy włączony": "Delivery method enabled",
        "Sposób dostawy został dodany.": "Delivery method has been added.",
        "Sposób dostawy został usunięty.": "Delivery method has been deleted.",
        "Sposób dostawy został zaktualizowany.": "Delivery method has been updated.",
        "Sposób płatności włączony": "Payment method enabled",
        "Sposób płatności został dodany.": "Payment method has been added.",
        "Sposób płatności został usunięty.": "Payment method has been deleted.",
        "Sposób płatności został zaktualizowany.": "Payment method has been updated.",
        "Sposób wyświetlania kafelków kategorii w katalogu produktów": "Display method of category tiles in product catalog",
        "Sprzedaż": "Sales",
        "Stały": "Fixed",
        "Stan magazynowy": "Stock level",
        "Stan magazynu": "Stock",
        "Status": "Status",
        "Status dostawy": "Delivery status",
        "Status faktury": "Invoice status",
        "Status kupującego": "Buyer status",
        "Status opinii": "Review status",
        "Status płatności": "Payment status",
        "Status zamówienia": "Order status",
        "Status zgłoszenia": "Request status",
        "Status został zmieniony": "Status has been changed",
        "Stawka domyślna": "Default rate",
        "Stawka podatku": "Tax rate",
        "Stawka została dodana.": "Rate has been added.",
        "Stawka została usunięta.": "Rate has been deleted.",
        "Stawka została zaktualizowana.": "Rate has been updated.",
        "Stawki podatku w poszczególnych państwach": "Tax rates in individual countries",
        "Strefa czasowa": "Time zone",
        "Strona została dodana.": "Page has been added.",
        "Strona została usunięta.": "Page has been deleted.",
        "Strona została zaktualizowana.": "Page has been updated.",
        "Styl dekoracji tekstu": "Text decoration style",
        "Styl obramowania": "Border style",
        "Sugerowana cena": "Suggested price",
        "Symbol": "Symbol",
        "Symbol kategorii": "Category symbol",
        "Symbol może składać się tylko z małych liter, cyfr oraz znaku - ": "Symbol can consist only of lowercase letters, digits, and - character ",
        "Synchronizuj": "Synchronize",
        "System opinii włączony": "Review system enabled",
        "Szablon": "Template",
        "Szczegóły faktury": "Invoice details",
        "Szczegóły kolekcji": "Collection details",
        "Szczegóły opinii": "Review details",
        "Szczegóły wartości": "Value details",
        "Szczegóły zamówienia": "Order details",
        "Szczegóły zgłoszenia": "Request details",
        "Szerokość": "Width",
        "szt": "pcs",
        "Środowisko": "Environment",
        "Tak": "Yes",
        "Tekst wyświetlany podczas ustawienia blokady": "Text displayed when lock is set",
        "Telefon": "Phone",
        "Token API ShipX": "ShipX API token",
        "Token Geowidget": "Geowidget token",
        "tPay": "tPay",
        "Treść notatki": "Note content",
        "Treść opinii": "Review content",
        "Tworzenie cennika": "Creating price list",
        "Tworzenie faktury": "Creating invoice",
        "Tworzenie wariantów": "Creating variants",
        "Typ": "Type",
        "Typ dostawy": "Delivery type",
        "Typ kodu": "Code type",
        "Typ notatki": "Note type",
        "Typ rabatu": "Discount type",
        "Tytuł": "Title",
        "Ukryj kafelki": "Hide tiles",
        "Ulica": "Street",
        "URL płatności": "Payment URL",
        "Ustawienia domyślne": "Default settings",
        "Ustawienia Dotpay": "Dotpay settings",
        "Ustawienia historii przeglądanych produktów": "Viewed product history settings",
        "Ustawienia katalogu produktów": "Product catalog settings",
        "Ustawienia kategorii": "Category settings",
        "Ustawienia kodu pocztowego": "Postal code settings",
        "Ustawienia limitu kupieckiego": "Trade credit limit settings",
        "Ustawienia PayPal": "PayPal settings",
        "Ustawienia PayU": "PayU settings",
        "Ustawienia podstawowe": "Basic settings",
        "Ustawienia przelewu tradycyjnego": "Traditional bank transfer settings",
        "Ustawienia Przelewy24": "Przelewy24 settings",
        "Ustawienia rabatu": "Discount settings",
        "Ustawienia sklepu": "Store settings",
        "Ustawienia tPay": "tPay settings",
        "Ustawienia webservice": "Webservice settings",
        "Ustawienia wyświetlania": "Display settings",
        "Ustawienia zostały zapisane.": "Settings have been saved.",
        "Usuń": "Delete",
        "Usuń cechę": "delete attribute",
        "Usuń katalog": "delete catalog",
        "Usuń kategorię": "delete category",
        "Usuń producenta": "delete manufacturer",
        "Usuń produkt": "delete product",
        "Usuwanie opinii": "Deleting reviews",
        "Usuwanie produktów": "Deleting products",
        "Utworzona": "Created",
        "Utworzył": "Created",
        "Utwórz": "Create",
        "Uwzględnij dodatkowe koszty pakowania produktów": "Include additional product packaging costs",
        "Użyj niestandardowego wzoru": "Use custom pattern",
        "Użytkownik": "User",
        "W magazynie": "In stock",
        "W tym katalogu nie ma jeszcze żadnych kategorii.": "There are no categories in this catalog yet.",
        "Waga": "Weight",
        "Waluta": "Currency",
        "Waluta została dodana.": "Currency has been added.",
        "Waluta została usunięta.": "Currency has been deleted.",
        "Waluta została zaktualizowana.": "Currency has been updated.",
        "Waluty": "Currencies",
        "Wariant produktu": "Product variant",
        "Warianty": "Variants",
        "Warianty prodktu zostały utworzone.": "Product variants have been created.",
        "Wartości": "Values",
        "Wartości cechy": "Attribute values",
        "Wartości liczbowa": "Numeric values",
        "Wartości numeryczne": "Numeric values",
        "Wartości tekstowa": "Text values",
        "Wartość": "Value",
        "Wartość numeryczna": "Numeric value",
        "Wartość rabatu": "Discount value",
        "Wartość tekstowa": "Text value",
        "Wartość wymagana": "Required value",
        "Wartość została dodana.": "Value has been added.",
        "Wartość została zaktualizowana.": "Value has been updated.",
        "Wersja API": "API version",
        "Wiadomość": "Message",
        "Wielkość obramowania": "Border size",
        "Wielkość tekstu": "Text size",
        "Witryny": "Sites",
        "Właściwości": "Properties",
        "Włącz dodatkowe pola dla reklamacji": "Enable additional fields for complaints",
        "Wpis aktywny": "Active entry",
        "Wpis do kalendarza został usunięty.": "Calendar entry has been deleted.",
        "Wpis do kalendarza został zaktualizowany.": "Calendar entry has been updated.",
        "Wpis w kalendarzu został dodany.": "Calendar entry has been added.",
        "Wpis w kalendarzu został zaktualizowany.": "Calendar entry has been updated.",
        "Wpisz wartości po przecinku.": "Enter values separated by commas.",
        "Wpływ na wariantowość produktu": "Impact on product variants",
        "Wprowadź kod rabatowy...": "Enter discount code...",
        "Wprowadź nazwę promocji...": "Enter promotion name...",
        "Wprowadź opis zmiany statusu...": "Enter status change description...",
        "Wprowadź treść": "Enter content",
        "Wstąpił błąd przy dodawaniu notatki.": "An error occurred while adding note.",
        "Wstąpił błąd przy usuwaniu notatki.": "An error occurred while deleting note.",
        "Wszystkie": "All",
        "Wszystkie wersje językowe zostały już przypisane do innych sklepów.": "All language versions have already been assigned to other stores.",
        "Wszystko": "Everything",
        "wybierz": "select",
        "Wybierz cechę": "Select attribute",
        "Wybierz datę": "Select date",
        "Wybierz etykietę, którą chcesz przypisać do produktów": "Select label you want to assign to products",
        "Wybierz etykiety produktów": "Select product labels",
        "Wybierz formularz zawierający dodatkowe pola dla reklamacji": "Select form containing additional fields for complaints",
        "Wybierz kategorię": "Select category",
        "Wybierz kategorię, którą chcesz przypisać do produktów": "Select category you want to assign to products",
        "Wybierz kolekcję": "Select collection",
        "Wybierz kolekcję, którą chcesz przypisać do produktów": "Select collection you want to assign to products",
        "Wybierz opinie dla których chcesz wykonać akcje": "Select reviews for which you want to perform actions",
        "Wybierz poziom": "Select level",
        "Wybierz producenta, którego chcesz przypisać do produktów": "Select manufacturer you want to assign to products",
        "Wybierz producentów": "Select manufacturers",
        "Wybierz produkt": "Select product",
        "Wybierz produkt komplementarny": "Select complementary product",
        "Wybierz produkt rekomendowane": "Select recommended product",
        "Wybierz produkty": "Select products",
        "Wybierz produkty dla których chcesz wykonać akcje": "Select products for which you want to perform actions",
        "Wybierz status": "Select status",
        "Wybierz status który chcesz przypisać do opinii": "Select status you want to assign to reviews",
        "Wybierz zakres godzinowy": "Select time range",
        "Wybrana dostawa": "Selected delivery",
        "Wybrana płatność": "Selected payment",
        "Wybranie etykiety produktu jest wymagane": "Selecting product label is required",
        "Wybranie formatu jest wymagane": "Selecting format is required",
        "Wybranie kategorii jest wymagane": "Selecting category is required",
        "Wybranie limitu jest wymagane": "Selecting limit is required",
        "Wybranie producenta jest wymagane": "Selecting manufacturer is required",
        "Wybranie produktu jest wymagane": "Selecting product is required",
        "Wybrano jeden produkt.": "One product selected.",
        "Wybrano jedną opinię.": "One review selected.",
        "Wybranych opinii: %0": "Selected reviews: %0",
        "Wybranych produktów: %0": "Selected products: %0",
        "Wygenerowanie nowych kodów spowoduje usunięcie wszystkich istniejących kodów dla tej promocji. Usunięte kody są nieważne i nie można ich już użyć.": "Generating new codes will delete all existing codes for this promotion. Deleted codes are invalid and can no longer be used.",
        "Wyjaśnienie": "Explanation",
        "Wymagany kod pocztowy": "Postal code required",
        "Wysłane": "Sent",
        "Wysłane powiadomienia": "Sent notifications",
        "Wysokość": "Height",
        "Wystawiona ocena": "Given rating",
        "Wystąpił błąd podczas ładowania danych. Odśwież stronę i spróbuj ponownie": "An error occurred while loading data. Refresh page and try again",
        "Wystąpił błąd podczas próby exportu kodów promocyjnych.": "An error occurred while exporting promotional codes.",
        "Wystąpił błąd podczas zmiany statusu": "An error occurred while changing status",
        "Wystąpił błąd serwera podczas obsługiwania wybranej operacji. Spróbuj ponownie.": "Server error occurred during selected operation. Try again.",
        "Wystąpiły błędy w formularzu. Sprawdź wszystkie pola formularza.": "Errors in form. Check all form fields.",
        "Wysyłka na palecie": "Pallet shipping",
        "wyszukaj etykietę...": "search label...",
        "Wyszukaj etykietę...": "Search label...",
        "wyszukaj kategorię...": "search category...",
        "wyszukaj kolekcję...": "search collection...",
        "wyszukaj producenta...": "search manufacturer...",
        "Wyszukaj producenta...": "Search manufacturer...",
        "Wyszukaj produkt...": "Search product...",
        "Wyszukaj rodzaj płatności...": "Search payment type...",
        "Wyszukaj sklep...": "Search store...",
        "Wyszukaj sposób dostawy...": "Search delivery method...",
        "Wyszukaj użytkownika...": "Search user...",
        "Wyszukaj walutę...": "Search currency...",
        "Wzór kodu pocztowego": "Postal code pattern",
        "Wzór kodu pocztowego, który będzie wyświetlany w komunikacie błędnej walidacji": "Postal code pattern that will be displayed in invalid validation message",
        "Zaakceptowane": "Accepted",
        "Zachowanie przy braku towaru na stanie": "Behavior when item is out of stock",
        "zacznij pisać aby wyszukać cechę...": "start typing to search attribute...",
        "zacznij pisać aby wyszukać etykietę...": "start typing to search label...",
        "zacznij pisać aby wyszukać grupę...": "start typing to search group...",
        "zacznij pisać aby wyszukać kolekcję...": "start typing to search collection...",
        "zacznij pisać aby wyszukać kraj...": "start typing to search country...",
        "zacznij pisać aby wyszukać podatek...": "start typing to search tax...",
        "zacznij pisać aby wyszukać producenta...": "start typing to search manufacturer...",
        "zacznij pisać aby wyszukać produkt...": "start typing to search product...",
        "zacznij pisać aby wyszukać sklep...": "start typing to search store...",
        "zacznij pisać aby wyszukać walutę...": "start typing to search currency...",
        "Załączniki": "Attachments",
        "Zamawianie bez rejestracji, przez niezalogowanych klientów": "Ordering without registration, by non-logged-in customers",
        "Zamiany zostały zapisane.": "Changes have been saved.",
        "Zamknij": "Close",
        "Zamówienia": "Orders",
        "Zamówienie": "Order",
        "Zamówienie złożone": "Order placed",
        "Zamówienie zostało zaktualizowane.": "Order has been updated.",
        "Zapisuj logi": "Save logs",
        "Zapisz": "Save",
        "Zapisz i wróć": "Save and back",
        "Zapisz notatkę": "Save note",
        "Zapisz zmiany": "Save changes",
        "Zapłacono brutto": "Gross paid",
        "Zarządzaj opiniami": "Manage reviews",
        "Zawiera produkt": "Contains product",
        "Zaznacz jako kategorię domyślną": "Mark as default category",
        "Zaznaczone": "Selected",
        "Zdjęcia": "Images",
        "Zdjęcie": "Image",
        "Zdjęcie główne": "Main image",
        "Zdjęcie produktu": "Product image",
        "Ze statusu": "From status",
        "Zgłoszenie": "Request",
        "Zmiana statusu": "Status change",
        "Zmiany zostały zapisane.": "Changes have been saved.",
        "Zmienił": "Changed by",
        "Zmodyfikowane przez": "Modified by",
        "Zwroty i reklamacje": "Returns and complaints",
        "Źródło (utm_source)": "Source (utm_source)",
        "Żródła": "Sources"
    }
};
